import { render, staticRenderFns } from "./weapp.vue?vue&type=template&id=af7a1d40&scoped=true"
import script from "./weapp.vue?vue&type=script&lang=js"
export * from "./weapp.vue?vue&type=script&lang=js"
import style0 from "./weapp.vue?vue&type=style&index=0&id=af7a1d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7a1d40",
  null
  
)

export default component.exports